import { DocumentIsogd } from "isogd-document-rest";

class RegistrationStatusController {
    private document: DocumentIsogd;
    private statuses: any[];
    private color: string;
    private value: string;

    constructor() {
    }

    $onInit() {
        this.statuses.forEach(s => {
            if (s.code === this.document.registration.registrationStatus) {
                this.color = s.color;
                this.value = s.name;
            }
        });
    }
}

export const RegistrationStatusComponent: angular.IComponentOptions = {
    controller: RegistrationStatusController,
    template: require('./registrationStatus.html'),
    bindings: {
        document: '<',
        statuses: '<'
    }
};



// WEBPACK FOOTER //
// ./src/components/registration-status/registrationStatus.ts